define("shared/utils/formatters/ig-post-from-instagram", ["exports", "@ember/utils", "later/models/ig-post"], function (_exports, _utils, _igPost) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/utils",0,"later/models/ig-post"eaimeta@70e063a35619d71f

  function createIgPostFromInstagram(obj, socialProfile) {
    const attrs = {};
    attrs.timeCollected = Date.now();
    attrs.hasMedia = true;
    attrs.socialProfile = socialProfile;
    attrs.id = obj.id;
    attrs.isDeleted = obj.is_deleted || false;
    attrs.createdTime = obj.created_time;
    attrs.type = obj.type;
    attrs.link = obj.link;
    attrs.userHasLiked = obj.user_has_liked;
    attrs.igId = obj.id;

    if (!(0, _utils.isNone)(obj.carousel_media)) {
      attrs.isCarousel = obj.carousel_media.length > 0;
    } else {
      attrs.isCarousel = false;
    }

    if (!(0, _utils.isNone)(obj.comments)) {
      attrs.commentCount = obj.comments.count;
    }

    if (!(0, _utils.isNone)(obj.likes)) {
      attrs.likeCount = obj.likes.count;
    }

    if (!(0, _utils.isNone)(obj.images)) {
      attrs.lowResUrl = obj.images.low_resolution.url;
      attrs.thumbUrl = obj.images.thumbnail.url;
      attrs.standardResUrl = obj.images.standard_resolution.url;
    }

    if (!(0, _utils.isNone)(obj.videos)) {
      attrs.lowBandwidthVideoUrl = obj.videos.low_bandwidth.url;
      attrs.lowResVideoUrl = obj.videos.low_resolution.url;
      attrs.standardResVideoUrl = obj.videos.standard_resolution.url;
    }

    if (!(0, _utils.isNone)(obj.caption)) {
      attrs.caption = obj.caption.text;
    }

    if (!(0, _utils.isNone)(obj.tags)) {
      attrs.tags = obj.tags;
    }

    if (!(0, _utils.isNone)(obj.user)) {
      attrs.userId = obj.user.id;
      attrs.username = obj.user.username;
      attrs.userProfileUrl = obj.user.profile_picture;
    }

    if (!(0, _utils.isNone)(obj.location)) {
      attrs.locationName = obj.location.name;
      attrs.locationId = obj.location.id;
    }

    return _igPost.default.create(attrs);
  }

  var _default = createIgPostFromInstagram;
  _exports.default = _default;
});